













import { Component, Prop, Vue} from 'vue-property-decorator';
import Header from '@/components/menu/Header.vue'; // @ is an alias to /src

@Component({
  components: {
	  Header
  }
})
export default class Error404 extends Vue {}
